import script from "./providerCommons.vue?vue&type=script&lang=js"
export * from "./providerCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__